/**
 * 利用規約同意チェックボックスとボタン状態を管理するモジュール
 */
export default class TermsAcceptanceHandler {
  /**
   * @param {Object} options - 設定オプション
   * @param {string} options.submitButtonSelector - 送信ボタンのセレクタ
   * @param {string} options.singleCheckboxSelector - 単一チェックボックスのセレクタ（オプション）
   * @param {string} options.multipleCheckboxesSelector - 複数チェックボックスのセレクタ（オプション）
   */
  constructor(options) {
    this.submitButtonSelector = options.submitButtonSelector;
    this.singleCheckboxSelector = options.singleCheckboxSelector;
    this.multipleCheckboxesSelector = options.multipleCheckboxesSelector;
    
    this.submitButton = document.querySelector(this.submitButtonSelector);
    this.singleCheckbox = document.querySelector(this.singleCheckboxSelector);
    this.multipleCheckboxes = document.querySelectorAll(this.multipleCheckboxesSelector);
  }

  /**
   * ボタンの状態を切り替える
   * @param {HTMLElement} button - 対象のボタン要素
   * @param {boolean} isDisabled - 無効化するかどうか
   */
  toggleButtonState(button, isDisabled) {
    button.disabled = isDisabled;
    button.classList.toggle('opacity-20', isDisabled);
    button.classList.toggle('opacity-100', !isDisabled);
  }

  /**
   * 送信ボタンの状態を更新する
   */
  updateSubmitButtonState = () => {
    if (this.multipleCheckboxes.length > 0) {
      const allChecked = [...this.multipleCheckboxes].every(checkbox => checkbox.checked);
      this.toggleButtonState(this.submitButton, !allChecked);
    } else if (this.singleCheckbox) {
      this.toggleButtonState(this.submitButton, !this.singleCheckbox.checked);
    } else {
      // 利用規約を表示しない場合はボタンを有効化
      this.toggleButtonState(this.submitButton, false);
    }
  };

  /**
   * イベントリスナーを初期化する
   */
  init() {
    if (!this.submitButton) return;

    // 初期状態の設定
    this.updateSubmitButtonState();

    // イベントリスナーの設定
    if (this.multipleCheckboxes.length > 0) {
      this.multipleCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', this.updateSubmitButtonState);
      });
    } else if (this.singleCheckbox) {
      this.singleCheckbox.addEventListener('change', this.updateSubmitButtonState);
    }
  }
}
